import { ERouterList } from '@internal/router/constants/router-list'

import EmptyLayout from '@internal/layouts/empty-layout.vue'

import { guest } from '@internal/router/middleware/guest'

export const anonymous = [
  {
    path: '/anonymous/consents/:token',
    name: ERouterList.ANONYMOUS_CONSENTS_TOKEN,
    component: () => import('@internal/pages/anonymous/consents/_token/index.vue'),
    meta: {
      middleware: [guest],
      layout: EmptyLayout,
    },
  },
  {
    path: '/anonymous/consents/:token/consent-signed',
    name: ERouterList.ANONYMOUS_CONSENTS_TOKEN_CONSENT_SIGNED,
    component: () => import('@/internal/src/pages/anonymous/consents/_token/consent-signed.vue'),
    meta: {
      middleware: [guest],
      layout: EmptyLayout,
    },
  },
  {
    path: '/anonymous/consents/:token/link-expired',
    name: ERouterList.ANONYMOUS_CONSENTS_TOKEN_LINK_EXPIRED,
    component: () => import('@/internal/src/pages/anonymous/consents/_token/link-expired.vue'),
    meta: {
      middleware: [guest],
      layout: EmptyLayout,
    },
  },
  {
    path: '/anonymous/consents/:token/link-no-available',
    name: ERouterList.ANONYMOUS_CONSENTS_TOKEN_LINK_NO_AVAILABLE,
    component: () => import('@/internal/src/pages/anonymous/consents/_token/link-no-available.vue'),
    meta: {
      middleware: [guest],
      layout: EmptyLayout,
    },
  },
]

export default anonymous
